// extracted by mini-css-extract-plugin
export default {"latestEvents":"LatestEvents_latestEvents__GKQe1","latestEvents__topLine":"LatestEvents_latestEvents__topLine__TsVOl"};